var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detail.content)?_c('p',{staticClass:"doc-detail",domProps:{"innerHTML":_vm._s(_vm.detail.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }